<template>
  <ExActionsPopUp
    :value="value"
    :headline="`Detach Role`"
    :htmlInfo="info"
    actionLabel="Detach"
    @input="$emit('input', $event)"
    @onAction="$emit('onAction')"
    data-testid="detach-role-popup"
    icon="org_icon_role"
    :applyBorderClass="true"
    :width="500"
    :centerHeadline="true"
    actionsTopSpacing="32px"
  >
  </ExActionsPopUp>
</template>
<script setup>
import { computed, defineProps } from 'vue';
import ExActionsPopUp from "@components/common/ExActionsPopUp.vue";
const props = defineProps({
    value: {
        type: Boolean,
        default: false
    },
    role_name: {
        type: String,
        default: ""
    },
    parent_name: {
        type: String,
        default: ""
    },
    /** When `responsibility`, copy reflects detaching a role from a responsibility (not from a position). */
    parent_kind: {
        type: String,
        default: "position",
        validator: (v) => ["position", "responsibility"].includes(v),
    },
});

const info = computed(() => {
  const role = props.role_name || "";
  const parent = props.parent_name || "";
  if (props.parent_kind === "responsibility") {
    return `<div style="margin-top: 20px;">You are about to detach Role ${role} from Responsibility ${parent}.<br /><br />This action will irreversibly detach all assignments of this responsibility for employees that have the role assigned.</div>`;
  }
  return `<div style="margin-top: 20px;">You are about to detach Role ${role} from ${parent}<br /><br /> This action will irreversibly detach all assignments to this role as well as all assignments to responsibilities attached to this role.</div>`;
});
</script>